export const API = {
    auth: {
        loginUser: "auth/login",
        loginVerifyOtp: "auth/verify-otp"
    },
    panel: {
        // sayyarpay
        loginAdmin: "auth/login",
        getUserInfo: "admin/users",
        getAllUsers: "admin/users/all",
        searchUser: "admin/users/search",
        getTotalUsers: "admin/users/total",
        getDashboardStats: "admin/dashboard/stats",
        getTotalCommisions: "admin/users/commissions-count",
        getTotalWallets: "admin/users/wallets-count",
        getTotalTransactions: "admin/users/transactions-count",
        getSystemLogs: "admin/logs/all",
        getUserFinancialLogs: "admin/logs/user-financial",
        chargeUserWallet: "admin/users/charge",
        dechargeUserWallet: "admin/users/decharge",
        getNotVerifiedUsers: "admin/users/not-verified",
        getUserAcceptedAuth: "admin/users/accepted-verify-auth",
        getExternalTransactions: "admin/external-transactions/all",
        getUserTransactions: "admin/users/transactions",
        getUserExternalTransactions: "admin/external-transactions/user",
        getAllWithdrawals: "admin/withdrawals/all",
        getUserWithdrawals: "admin/withdrawals/user",
        acceptUserIdentify: "admin/users/accept-auth",
        rejectUserIdentify: "admin/users/reject-auth",
        getSettingsSystem: "admin/settings",
        editSystemSetting: "admin/settings",
        getPaymentSetting: "admin/settings/payment",
        updatePaymentSetting: "admin/settings/payment",
        getGateways: "admin/gateways/all",
        getGatewayInfo: "admin/gateways",
        getGatewayTransactions: "admin/gateways/transactions",
        getCommissions: "admin/commission-log/all",
        getDepositTransferHistory: "admin/deposit/history",
        toggleGatewayStatus: "admin/gateways/verify",
        getGatewaySettlementSettings: "admin/gateways/setting",
        updateGatewaySettlementSettings: "admin/gateways/setting",
        GetWithdrawalsCrypto: "admin/withdrawals/crypto",
        GetAcceptedWithdrawalsCrypto: "admin/withdrawals/crypto/accepted",
        GetRejectedWithdrawalsCrypto: "admin/withdrawals/crypto/rejected",
        manualCharges: {
            list: "https://api.sayyarpay.top/api/admin/manual-charges",
            crypto: "https://api.sayyarpay.top/api/admin/manual-charges/crypto",
            approve: "https://api.sayyarpay.top/api/admin/manual-charges",
            reject: "https://api.sayyarpay.top/api/admin/manual-charges",
            stats: "https://api.sayyarpay.top/api/admin/manual-charges/stats"
        },
        acceptUsdtCharge: "admin/withdrawals/accept-charge-usdt",
        rejectUsdtCharge: "admin/withdrawals/reject-charge-usdt",
        sendUserNotification: "admin/notifications",
        sendGroupNotofication: "admin/notifications/group",
        getExchangeSetting: "admin/settings/exchange-setting",
        updateExchangeSetting: "admin/settings/exchange-setting",
        getFullTransactiosReport: "admin/external-transactions",
        getTransactionsReportExcel: "admin/external-transactions/excel"
    },
};
